@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../constants/spacing.module.less';
@import '../../../../../constants/screen-width-breakpoints.module.less';

.ftu-help-center {
  width: 100%;
  color: var(--white);
  background-color: var(--green-1E4230);
  border-radius: 8px;
  padding: @space-16;
  border: 1px solid var(--green-0B5C35);
}

.help-center-icon {
  display: flex;
  justify-content: center;
  margin-bottom: @space-16;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: var(--white);
  background-image: url('../../../../../svgs/help-desk-support-agent.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 50px 50px;
}

.help-center-title {
  font-size: 16px;
  font-weight: 500;
}

.help-center-description {
  font-size: 12px;
  line-height: 1.4;
  margin: @space-4 0 @space-16;
}

.help-center-buttons {
  width: 100%;
  gap: @space-8;
}

.help-center-button {
  width: 100%;
  background-color: var(--white);
  border: 1px solid var(--white);

  &:hover {
    background-color: var(--gray-F4F6F8);
  }
}

.button-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: @space-8;
}

.button-icon {
  height: 18px;
  width: 18px;
}
